import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, Typography } from "@material-ui/core";
import t from "../../languages/pl";

const NoData = ({colSpan}) => {
    return (
        <TableRow>
            <TableCell
                style={{textAlign: "center"}}
                colSpan={colSpan}
            >
                <Typography variant="body1">
                    {t.noDataInfo}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

NoData.defaultTypes = {
    colSpan: 1
};

NoData.propTypes = {
    classes: PropTypes.object,
    colSpan: PropTypes.number
};

export default NoData;